import React, { useState, useEffect } from 'react';
import styles from '../../app.module.css';

const HeadersForm = ({ initialData, onSave, onCancel, existingHeaders = [] }) => {
    const [header, setHeader] = useState({
        name: '',
        required: false,
        description: '',
        schema: { type: '' },
    });

    const isEditing = !!initialData;

    const [popupMessage, setPopupMessage] = useState("");
    const [showPopup, setShowPopup] = useState(false);

    const showPopupModal = (message) => {
        setPopupMessage(message);
        setShowPopup(true);
    }

    useEffect(() => {
        if (initialData) {
            setHeader({
                name: initialData.name || '',
                required: initialData.required || false,
                description: initialData.description || '',
                schema: initialData.schema || { type: '' },
            });
        } else {
            setHeader({
                name: '',
                required: false,
                description: '',
                schema: { type: '' },
            });
        }
    }, [initialData]);

    const handleInputChange = (field, value) => {
        setHeader((prev) => ({ ...prev, [field]: value }));
    };

    const handleSchemaTypeChange = (value) => {
        setHeader((prev) => ({
            ...prev,
            schema: { ...prev.schema, type: value },
        }));
    };

    const handleSubmit = () => {
        if (!header.name || !header.schema.type) {
            showPopupModal('Name and Schema Type are required.');
            return;
        }

        const { name, ...headerData } = header;
        onSave(name, headerData);
    };

    return (
        <div className={styles.mainContainer}>
            <h3>{isEditing ? 'Edit Header' : 'Add Header'}</h3>

            {/* Name */}
            <div className={styles.style4}>
                <label>Name: <span className={styles.requiredField}>*</span></label>
                <input
                    type="text"
                    value={header.name}
                    onChange={(e) => handleInputChange('name', e.target.value)}
                    readOnly={isEditing}
                    placeholder="Enter Header Name"
                    style={{
                        width: '100%',
                        padding: '8px',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        marginBottom: '10px',
                        boxSizing: 'border-box',
                        backgroundColor: isEditing ? '#f5f5f5' : 'white',
                        color: isEditing ? '#888' : 'black',
                        cursor: isEditing ? 'not-allowed' : 'text',
                    }}
                />
            </div>

            {/* Required */}
            <div className={styles.style4}>
                <label className={styles.style4}>
                    <input
                        type="checkbox"
                        checked={header.required}
                        onChange={(e) => handleInputChange('required', e.target.checked)}
                    />
                    Required
                </label>
            </div>

            {/* Description */}
            <div className={styles.style4}>
                <label>Description:</label>
                <input
                    type="text"
                    value={header.description}
                    onChange={(e) => handleInputChange('description', e.target.value)}
                    placeholder="Enter Description"
                    className={styles.style1}
                />
            </div>

            {/* Schema Type */}
            <div className={styles.style4}>
                <label>Schema Type: <span className={styles.requiredField}>*</span></label>
                <select
                    value={header.schema.type}
                    onChange={(e) => handleSchemaTypeChange(e.target.value)}
                    className={styles.style1}
                >
                    <option value="">Select Type</option>
                    <option value="string">String</option>
                    <option value="integer">Integer</option>
                    <option value="boolean">Boolean</option>
                    <option value="array">Array</option>
                    <option value="object">Object</option>
                </select>
            </div>

            {/* Action Buttons */}
            <div className={styles.sNcButtonContainer}>
                <button
                    className={styles.saveButton}
                    onClick={handleSubmit}
                >
                    {isEditing ? 'Update' : 'Save'}
                </button>
                <button
                    className={styles.cancelButton}
                    onClick={onCancel}
                >
                    Cancel
                </button>
            </div>
            {showPopup && (
                <div className={styles.popupOverlay}>
                    <div className={styles.popup}>
                        <h3>Error</h3>
                        <p>{popupMessage}</p>
                        <button onClick={() => setShowPopup(false)} className="popup-close-button">
                            OK
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default HeadersForm;

